import { useContext, useLayoutEffect, useMemo, useRef } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { GeneralNames } from "../../../../namesConstants/names";
import { QueriesServiceManager } from "../../../../context/wrapperContext/queries/FilterContext";
import { useWindowResize } from "../../../../hooks/ui/useWindowResize";
import { useTableLayout } from "../../../../hooks/ui/useTableLayout";

const headerClassNameColumn =
  "hover:!text-success !bg-secondary-PCS004 !text-secondary-PCS001 !font-semibold !border-r-2 !border-secondary-PCS003 !font-bold !text-[14px] !font-karla";
const bodyClassName =
  "!border-b-0 !border-secondary-PCS004 !text-black !justify-start bg-white";

export const TableQueriesComponent = ({
  tableDataQuery,
  dynamicColumns,
  filters,
  sort,
  setSort,
  keyTable,
}) => {
  const { showColumnsDate } = useContext(QueriesServiceManager);

  const tableRef = useRef(null);

  const { stickyLefts, calculateStickyColumnsOffset, updateTableLayout } =
    useTableLayout({ tableRef });

  useLayoutEffect(() => {
    calculateStickyColumnsOffset();
  }, [dynamicColumns, tableDataQuery, calculateStickyColumnsOffset]);

  useWindowResize({
    callback: updateTableLayout,
  });

  const dynamicColumnsTableOpen = useMemo(
    () =>
      dynamicColumns?.open.map((col, i) => (
        <Column
          columnKey={i}
          style={{
            width: "150px",
            position: col.frozen ? "sticky" : undefined,
            left: col.frozen ? `${stickyLefts[i]}px` : "auto",
          }}
          headerStyle={{
            zIndex: col.frozen ? 1 : "auto",
          }}
          key={col.field}
          field={col.field}
          header={col.header}
          sortable={col.sortable}
          headerClassName={headerClassNameColumn}
          bodyClassName={bodyClassName}
          body={(rowData) =>
            col?.body !== undefined
              ? col?.body(rowData[col.field], col.field)
              : rowData[col.field]
          }
        />
      )),
    [dynamicColumns, stickyLefts]
  );

  const dynamicColumnsTableClose = useMemo(
    () =>
      dynamicColumns.close.map((col, i) => (
        <Column
          columnKey={i}
          style={{
            width: "150px",
            position: col.frozen ? "sticky" : undefined,
            left: col.frozen ? `${stickyLefts[i]}px` : "auto",
          }}
          headerStyle={{
            zIndex: col.frozen ? 1 : "auto",
          }}
          key={col.field}
          field={col.field}
          header={col.header}
          sortable={col.sortable}
          headerClassName={headerClassNameColumn}
          bodyClassName={bodyClassName}
          body={(rowData) =>
            col?.body !== undefined
              ? col?.body(rowData[col.field], col.field)
              : rowData[col.field]
          }
        />
      )),
    [dynamicColumns, stickyLefts]
  );

  return (
    <div className="flex w-full h-full relative">
      {tableDataQuery !== null ? (
        <DataTable
          ref={tableRef}
          key={keyTable}
          value={tableDataQuery}
          paginator
          rows={25}
          first={0}
          sortField={sort}
          sortOrder={sort}
          scrollable
          size="small"
          scrollHeight="flex"
          resizableColumns
          columnResizeMode="expand"
          filters={filters}
          emptyMessage={GeneralNames.GeneralEmptyMessage}
          globalFilterFields={[
            "Code",
            "CollaboratorName",
            "CollaboratorLead",
            "TotalHome",
            "TotalWork",
            "TotalUnknown",
            "timeAttendance",
            "quantityAttendance",
            "timeAbscense",
            "quantityAbscense",
            "timeDelay",
            "quantityDelay",
          ]}
          rowsPerPageOptions={[25, 50, 75, 100]}
          className="!flex !flex-col !w-full !h-full !relative !bg-transparent"
          tableStyle={{
            height: "100% !important",
            minHeight: "100% !important",
            background: "none",
            backgroundColor: "none",
          }}
          onSort={(e) => setSort(e.multiSortMeta)}
          multiSortMeta={sort}
          onColumnResizeEnd={updateTableLayout}
          sortMode="multiple"
          tableClassName="!overflow-scroll !flex-col !absolute inset-0"
          rowClassName="hover:!bg-[#3b82f6] !border-secondary-PCS004"
          paginatorClassName="!border-t !border-border !justify-start !text-xs !top-0 flex bg-white"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Total de registros {totalRecords}"
          responsiveLayout="scroll"
        >
          {showColumnsDate ? dynamicColumnsTableOpen : dynamicColumnsTableClose}
        </DataTable>
      ) : null}
    </div>
  );
};
